import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { registerLocaleData, DatePipe } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// Rutas
import { PAGES_ROUTES } from './pages.routes';

// Modulos
import { SharedModule } from '../shared/shared.modules';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';

// Componentes
import { DashboardComponent } from './dashboard/dashboard.component';
import { PagesComponent } from './pages.component';
import { PerfilnuevoComponent } from './perfiles/perfilnuevo.component';
import { PerfilesComponent } from './perfiles/perfiles.component';
import { AfficontrollComponent } from './afficontroll/afficontroll.component';

import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { NgxDateRangeModule } from 'ngx-daterange';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ArchwizardModule } from 'angular-archwizard';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
registerLocaleData(localeEs);

@NgModule({
  declarations: [
    PagesComponent,
    DashboardComponent,
    PerfilnuevoComponent,
    PerfilesComponent,
    AfficontrollComponent,
  ],
  exports: [
    DashboardComponent
  ],
  imports: [
    SharedModule,
    PAGES_ROUTES,
    FormsModule,
    BrowserAnimationsModule,
    AgGridModule.withComponents([]),
    NgxSpinnerModule,
    AutocompleteLibModule,
    NgxDateRangeModule,
    NgxMaskModule.forRoot(),
    NgSelectModule,
    ArchwizardModule,
  ],
  providers: [
    DatePipe
  ]
})
export class PagesModule { }
